<template>
  <div class="container">
    <mt-header fixed title="个人中心" class="head">
  </mt-header>
    <div class="user-info bg c_p_10">
        <div class="c_flex">
            <div class="user-headUrl c_flex c_flex_center" @click="editAvatarClick">
              <img v-if="userinfo.avatar" :src="qiniu+userinfo.avatar+'?imageView2/1/w/100/h/100'" alt="">
              <i v-else class="iconfont icon-wode"></i>
            </div>
            <div class="c_flex c_flex_1 c_nowrap c_p_l_10">
                <div class="c_flex_1 c_left">
                    <div class="c_nowrap c_m_t_10"> {{userinfo.username}}</div>
                    <div class="c_nowrap c_m_t_10">
                      {{userinfo.sexid == 1?'男':(userinfo.sexid==2?'女':'未知')}} ， {{userinfo.userphone}}
                    </div>
                </div>
                <div class="c_flex c_flex_center">

                </div>
            </div>
        </div>
    </div>
    <div class="c_m_t_10 bg_white" v-for="(menu,index) in menus" :key="index">
        <div class="info-group c_left c_flex" v-for="(item,index) in menu" :key="index" v-if="item.isAuth" @click="item.callback">
          <div class="info-head c_flex_1 c_flex c_item_center">
              <div class="info-img c_m_r_10">
                <i class="iconfont" :class="item.img"></i>
              </div>
              <div class="info-title c_nowrap">
                {{item.name}}
              </div>
          </div>
          <div class="info-opera" v-show="!item.isOpera">
            <i class="iconfont icon-jiantou"></i>
          </div>
        </div>
    </div>
    <!--<div style="height: 55px;"></div>-->
    <!--选择角色-->
    <mt-actionsheet
      :actions="roleParam.roleList"
      :closeOnClickModal="false"
      v-model="roleParam.visible">
    </mt-actionsheet>
  </div>
</template>

<script>
    export default {
        name: "account",
        data:function () {
          return {
            qiniu: this.$$api.mobile.qiniuDownload,
            userinfo:{
              userid:'',
              username:'你好！',
              avatar:'',
              sexid:0,
              userphone:'18435114682',
              usertype:'',  // customer ,客户。  sysuser 管家，勘察,  construction 工队
            },
            roleParam:{
              visible:false,
              roleList:[],
            },
            menus:[
              [
                { id:'menu-1',isAuth:true,name:'修改姓名',img:'icon-xiugai1 c_blue',callback: this.editNameClick },
                { id:'menu-2',isAuth:true,name:'切换角色',img:'icon-xiugai1 c_blue',callback: this.editRoleClick },
              ],
              [
                { id:'menu-3',isAuth:false,name:'创建施工订单',img:'icon-jiahao c_blue',callback: this.toBookserviceClick },
                { id:'menu-4',isAuth:false,name:'我的合同',img:'icon-xiaoshouhetong c_blue',callback: this.toContractClick },
                { id:'menu-5',isAuth:false,name:'预约维修',img:'icon-jiahao c_blue',callback: this.toBookserviceClick },
                { id:'menu-6',isAuth:true,name:'我的报价',img:'icon-baojia c_blue',callback: this.toOrderClick },
              ],
              [
                { id:'menu-6',isAuth:true,name:'我的质保',img:'icon-xiaoshouhetong c_blue',callback: this.toGuaranteClick },
                // { id:'menu-7',isAuth:true,name:'我的发票',img:'icon-xiaoshouhetong c_blue',callback: this.toInvoiceClick},
              ],
              [
                { id:'menu-9',isAuth:false,name:'个人名片',img:'icon-xiaoshouhetong c_blue',callback: this.toPersonalInfoClick },
              ],
              [
                { id:'menu-8',isAuth:true,isOpera:true,name:'退出登录',img:'icon-zhuxiao c_blue',callback: this.logout },
              ],
            ],
          }
        },
        mounted:function () {
          if(localStorage['userinfo'])this.userinfo = localStorage['userinfo'];
          this.getUserInfo();

        },
        methods:{
          getUserInfo:function(){
            let $that = this;
            this.$ajax.get( this.$$api.mobile.getUserInfo, {} ,response=>{
              if (response.status >= 200 && response.status < 300) {
                let msg = response.data.detailMsg.data;
                $that.userinfo = msg||'';
                localStorage['userinfo'] = JSON.stringify(msg);
                $that.usertype = msg.usertype;
                if(msg.usertype == 'customer'){
                  $that.menus[1][1].isAuth = true;
                  $that.menus[1][3].isAuth = true;
                  $that.menus[2][0].isAuth = true;
                  $that.menus[2][1].isAuth = true;
                }else if(msg.usertype == 'construction'){
                  $that.menus[1][0].isAuth = true;
                }else if(msg.usertype == 'sysuser'){
                  $that.menus[1][0].isAuth = true;
                  $that.menus[1][1].isAuth = true;
                  $that.menus[3][0].isAuth = true;
                }
              } else {
                console.log(response,0);
              }
            });
          },
          editAvatarClick:function () {
            if(this.usertype && this.usertype != 'customer'){
              let img = this.userinfo.avatar||'';
              this.$router.push({name: "avatar", params: {'img':img }});
            }
          },
          editNameClick:function () {
            let name = this.userinfo.username||'';
            this.$router.push({name: "search", params: {'type': 'ajax','isOpera':true,'api':'editUserName','tips':'请输入姓名','title':'修改名称','val':name}});

          },
          editPhoneClick:function () {
            let phone = this.userinfo.userphone||'';
            this.$router.push({name: "search", params: {'type': 'ajax','isOpera':true,'api':'editUserPhone','tips':'请输入手机号','title':'修改手机号','val':phone}});
          },
          toContractClick:function () {
              console.log('contract');
              this.$router.push('/contract');
          },
          toBookserviceClick:function () {
              console.log('contractClick');
              this.$router.push('/bookservice');
          },
          // 质保
          toGuaranteClick:function () {
              // console.log('toGuaranteClick');
              this.$router.push('/guarante');
            // this.$toast("功能正在升级...");
          },
          //个人名片
          toPersonalInfoClick:function () {
              console.log('toPersonalInfoClick');
              var shareUserId = this.userinfo.userid;
              this.$router.push('/personalinfo?shareuserid='+shareUserId);
          },
          //发票
          toInvoiceClick:function () {
              // console.log('toInvoiceClick');
              this.$router.push('/invoice');
            // this.$toast("功能正在升级...");
          },
          //报价订单
          toOrderClick:function () {
              // console.log('toInvoiceClick');
              this.$router.push('/reportOrder');
            // this.$toast("功能正在升级...");
          },
          logout:function () {
            var $that = this;
            this.$messagebox.confirm('确定要注销吗?',{
              confirmButtonText:'注销'
            }).then(action => {
              if(action =='confirm'){
                $that.$ajax.post(this.$$api.mobile.logout,{},function () {
                });
                $that.$router.push('/login');
              }
            });

          },
          editRoleClick(){
            let $that = this;
            this.$ajax.get(this.$$api.mobile.getUserRole,{
              phone:this.userinfo.userphone
            },function (res) {
              if (res.status == 200) {
                let roleList = res.data.detailMsg.data||[];
                let temp = roleList.map(sub=>{
                  sub.name = sub.rolename;
                  sub.method = $that.chooseRole;
                  return sub;
                });
                $that.roleParam.roleList = temp;
                $that.roleParam.visible = true;
              }
            });
          },
          chooseRole(item){
            let $that = this;
            let username = this.userinfo.userphone;
            let login_roleid = item.id;
            this.$ajax.get(this.$$api.mobile.toggleUserRole,{
              username,
              login_roleid,
            },function (res) {
              if (res.status == 200) {
                $that.$toast('切换成功');
                let data = res.data||{};
                var obj = JSON.parse(localStorage['userinfo'])||{};
                obj.userid = data.tenantid;
                obj.iswarranty = data.iswarranty;
                obj.usertype = data.userType;
                localStorage['userinfo'] = JSON.stringify(obj);
                $that.roleParam.visible = false;
                $that.getUserInfo();
              }
            });
          },
        },

    }
</script>

<style scoped>
  .container{
    font-size:4vw;
  }
  .bg{
    background: -webkit-gradient(linear,left top, right top,from(#33485D), to(#4B7299));
    background: linear-gradient(to right,#33485D, #4B7299);
    color: #fff;
  }

  .user-headUrl{
    border: 1px solid #fff;
    width: 17vw;
    height: 17vw;
    border-radius: 50%;
    overflow: hidden;
  }
  .user-headUrl i{
    /*min-width: 100%;*/
    /*min-hieght:100%;*/
    font-size: 7vw;
  }

  /*.info-group*/
  .info-group{
    box-sizing: border-box;
    margin: 0 3.226vw;
    padding: 3.226vw 0;
    font-size: 4vw;
  }
  .info-group:not(:last-child){
    border-bottom: 1px solid #ccc;
  }
  .info-img{
    width: 5.242vw;
    height: 5.242vw;
  }
  .info-img i{
    width: 100%;
    height: 100%;
    font-size: 5vw;
  }
  .info-title{
    display: flex;
    align-items: center;
  }
  .info-opera i{
    font-size: 5vw;
  }
  .user-headUrl img{
    width: 100%;
    height :100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/account.vue